import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import Cookies from 'js-cookie'
import axios from 'axios'
import 'core-js/stable';
import 'regenerator-runtime/runtime';


axios.interceptors.request.use((request => {

  const token = Cookies.get("jwtToken");

  if(token){
    request.headers.Authorization = `Bearer ${token}`
  }

  return request

}))

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>,
)
